import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { diff_match_patch } from '../../../../../../assets/js/diff_match_patch_uncompressed.js';

@Component({
  selector: 'app-clause-comparision-dialog',
  templateUrl: './clause-comparision-dialog.component.html',
  styleUrl: './clause-comparision-dialog.component.scss'
})
export class ClauseComparisionDialogComponent {
  editedClause: any;
  loggedClause: any;
  isLoading: boolean = false;
  nochange: boolean = true;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {

    if (this.data.clauseData.oldText == null || this.data.clauseData.oldText == "") {
      this.nochange = true;
    } else {
      this.nochange = false;
      var dmp = new diff_match_patch();
      dmp.Diff_Timeout = 0;
      var d = dmp.diff_main((this.data.clauseData.oldText == null) ? "" : this.data.clauseData.oldText, (this.data.clauseData.text == null) ? "" : this.data.clauseData.text, false);
      dmp.diff_cleanupSemantic(d);
      this.editedClause = dmp.diff_prettyHtml(d);

      this.loggedClause = dmp.different_prettyHtml(d);
    }
  }

  getFormattedDate(val): string {
    return moment(val).format('lll');
  }
}